import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import dataViewing from "../views/dataViewing/dataViewing.vue";
import EqMent from "../views/eqment/index.vue";
import userCenter from "../views/userCenter/index.vue";
import appointment from "../views/eqment/appointment/appointment.vue";
import eqmentappointmentmsg from "../views/eqment/appointment/eqmentappointmentmsg.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/dataViewing",
    name: "dataViewing",
    component: dataViewing,
  },
  {
    path: "/eqment",
    name: "eqment",
    component: EqMent,
  },
  {
    path: "/appointment",
    name: "appointment",
    component: appointment,
  },
  {
    path: "/eqmentappointmentmsg",
    name: "eqmentappointmentmsg",
    component: eqmentappointmentmsg,
  },
  {
    path: "/userCenter",
    name: "userCenter",
    component: userCenter,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err && err.name != 'NavigationDuplicated') this.replace('/404')
  })
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
export default router;
